import { authenticatedFetch } from '../../api/request';

export function requestUserDataExport() {
    return authenticatedFetch('/v5/users/dataExport/request', { method: 'POST' });
}

export function requestMediaExport() {
    return authenticatedFetch('/v5/users/dataExport/media/request', { method: 'POST' });
}
